import { render, staticRenderFns } from "./ActivateEmail.vue?vue&type=template&id=2b4b082e&scoped=true&"
import script from "./ActivateEmail.vue?vue&type=script&lang=js&"
export * from "./ActivateEmail.vue?vue&type=script&lang=js&"
import style0 from "./ActivateEmail.vue?vue&type=style&index=0&id=2b4b082e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4b082e",
  null
  
)

export default component.exports